/**
 * 提交联系方式到 HubSpot (适配 React)
 * @param {Object} formData - 表单数据对象，例如 { email, phone, company, product: [] }
 * @param {Function} t - 国际化翻译函数 (可选，如果不需要翻译可以传入原样返回的函数)
 */
export const submitContactForm = async (formData, t = (s) => s) => {
  const processedData = {
    ...formData,
    product: Array.isArray(formData.product) ? formData.product.map(val => t(val)).join(',') : formData.product
  };

  const wrapFields = (data) => {
    const fields = Object.keys(data).map(key => ({
      "objectTypeId": "0-1",
      "name": key === 'product' ? 'content' : key, // 映射到 HubSpot 的字段名
      "value": data[key]
    }));

    // 采集当前页面的 URL 参数 (如 utm_source 等)
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      fields.push({ "objectTypeId": "0-1", "name": key, "value": value });
    });

    return fields;
  };

  try {
    const response = await fetch('https://api.hsforms.com/submissions/v3/integration/submit/242049557/b0005396-3a85-4b2c-bb8f-c7d39c8f7699', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        fields: wrapFields(processedData)
      })
    });

    const result = await response.json();

    if (result.status === "error") throw new Error(result.message);

    if (window.gio) window.gio('track', 'SenseARTrial_Success', { 'registerType_var': 'SenseAR Trial' });
    if (window.uetq) window.uetq.push('event', 'signup', {});

    return { success: true, data: result };
  } catch (error) {
    console.error('Submit Failed:', error);
    return { success: false, error: error.message };
  }
};

export const checkFormField = (form, rules, field) => {
  const rule = rules[field];
  const value = form[field];

  let msg = ''

  if (!rule) return '';

  for(let r of rule) {
    if (r.required && (!value || value?.length === 0)) {
      msg = r.message;
      break;
    }

    if (r.reg && !r.reg.test(value)) {
      msg = r.message;
      break;
    }
  }

  return msg;
}

export const checkForm = (form, rules, errors) => {
  let isValid = true; 
  for (let field in form) {
    let msg = checkFormField(form, rules, field)
    if (msg){
      errors[field] = msg;
      isValid = false;
    } else {
      errors[field] = '';
    }
  } 

  return isValid;
};